<template>
  <header class="header">
    <nav class="nav">
      <!-- Brand -->
      <div class="brand">
        <span class="logo">♻</span>
        <span class="title">Greenbelt Garbage Management</span>
      </div>

      <!-- Hamburger -->
      <button class="hamburger" @click="toggleMenu">
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
      </button>

      <!-- Menu -->
      <ul :class="['menu', { open: menuOpen }]">
        <li v-if="isLoggedIn"><router-link to="/dashboard">Dashboard</router-link></li>
        <li v-if="isLoggedIn"><router-link to="/estates">Estates</router-link></li>
        <li v-if="isLoggedIn"><router-link to="/clients">Clients</router-link></li>
        <li v-if="isLoggedIn"><router-link to="/payments">Payments</router-link></li>
        <li v-if="isLoggedIn"><router-link to="/mpesa/payments">Mpesa</router-link></li>
        <li v-if="isLoggedIn"><router-link to="/messages">Messages</router-link></li>

        <li v-if="!isLoggedIn">
          <router-link class="login" to="/login">Login</router-link>
        </li>

        <li v-if="isLoggedIn">
          <a href="#" class="logout" @click.prevent="handleLogout">Logout</a>
        </li>
      </ul>
    </nav>
  </header>
</template>


<script>
export default {
  data() {
    return {
      menuOpen: false,
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },

  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    handleLogout() {
      this.$store.dispatch("clearToken");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.$router.push("/");
    },
  },

  mounted() {
    setInterval(() => {
      this.handleLogout();
    }, 3600000); // auto logout 1hr
  },
};
</script>

<style scoped>
.header {
  background: linear-gradient(90deg, #0f766e, #14b8a6);
  padding: 1rem 1.5rem;              /* ⬆ increased height */
  box-shadow: 0 6px 14px rgba(0,0,0,0.12);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Nav */
.nav {
  max-width: 1300px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Brand */
.brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: white;
}

.logo {
  font-size: 1.6rem;                 /* ⬆ bigger icon */
}

.title {
  font-size: 1.2rem;                 /* ⬆ bigger title */
  font-weight: 800;
  letter-spacing: 0.3px;
}

/* Menu */
.menu {
  display: flex;
  gap: 0.8rem;
  list-style: none;
}

.menu li a {
  color: white;
  padding: 0.6rem 1rem;              /* ⬆ bigger clickable area */
  border-radius: 8px;
  font-size: 0.95rem;                /* ⬆ text size */
  font-weight: 600;
  transition: background 0.25s, transform 0.15s;
}

.menu li a:hover,
.menu li a.router-link-active {
  background: rgba(255,255,255,0.18);
  transform: translateY(-1px);
}

/* Special buttons */
.login {
  background: white;
  color: #0f766e !important;
  font-weight: 700;
}

.logout {
  background: #ef4444;
  color: white !important;
}

/* Hamburger */
.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
}

.hamburger span {
  width: 26px;                        /* ⬆ bigger */
  height: 3px;
  background: white;
  transition: 0.3s;
}

/* Hamburger animation */
.hamburger span.open:nth-child(1) {
  transform: rotate(45deg) translateY(8px);
}
.hamburger span.open:nth-child(2) {
  opacity: 0;
}
.hamburger span.open:nth-child(3) {
  transform: rotate(-45deg) translateY(-8px);
}

/* Mobile */
@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .menu {
    position: absolute;
    top: 4.5rem;                      /* ⬆ more spacing */
    right: 1rem;
    background: white;
    flex-direction: column;
    width: 240px;                     /* ⬆ wider */
    padding: 0.8rem;
    border-radius: 12px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.2);
    display: none;
  }

  .menu.open {
    display: flex;
  }

  .menu li a {
    color: #065f46;
    font-size: 0.95rem;
  }

  .menu li a:hover {
    background: #ecfdf5;
  }

  .logout {
    background: #fee2e2;
    color: #991b1b !important;
  }
}
</style>

